import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = logged
  const [meta, setMeta] = useState({ degrees: [], specialties: [] });

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("ayur_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ayur_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/meta").then(({ data }) => setMeta(data)).catch(() => {});
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ayur_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("ayur_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ayur_token");
    setUser(false);
  };

  const updateMe = async (payload) => {
    const { data } = await api.put("/users/me", payload);
    setUser(data);
    return data;
  };

  const setFollowing = useCallback((id, on) => {
    setUser((u) => (u ? {
      ...u,
      following: on ? [...new Set([...(u.following || []), id])] : (u.following || []).filter((x) => x !== id),
    } : u));
  }, []);

  return (
    <AuthContext.Provider value={{ user, meta, login, register, logout, refresh, updateMe, setFollowing }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
